import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import {BLOCKS} from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";
import Button from "../../atoms/button/button";

// Styles //
import "./modalConocerTalento.scss";

interface ModalConoTalenProps extends React.ComponentProps<"div"> {
    children?: React.ReactNode
    showModal: boolean
    talentsSelectedIds: any
    onClose: () => void
}

const ModalConocerTalento: React.FC<ModalConoTalenProps> = (props: ModalConoTalenProps) => {
    const { children, 
            showModal,
            talentsSelectedIds,
            ...rest
    } = props
    const compClass = "cfmui-modal"

    const modalData = useStaticQuery(graphql`
        query MODALCONOCERTALENTO {
            contentfulContactenos(contentful_id: {eq: "3GcmRiVYaBkZDpvKITtHLX"}) {
                tituloPrincipal
                descripcion {
                    raw
                }
                descripcionFormulario {
                    raw
                }
                imagenesEmpleo {
                    file {
                        url
                        details {
                            image {
                                height
                                width
                            }
                        }
                    }
                }
                tituloBoton
            }
        }
    `);

    // Funcion para renderizar contenido de texto de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="m-modal-content__form__item__msg" >{children}</p>;
            },
        },
        renderText: (text) =>
        text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };
    
    const {
        tituloPrincipal,
        descripcion,
        descripcionFormulario,
        imagenesEmpleo,
        tituloBoton
    } = modalData.contentfulContactenos

    useEffect(() => {
        document.body.style.overflow = showModal ? "scroll" : "unset"
    }, [props.showModal])

    const attributes = {
        ...rest,
        className: `${rest.className ?? ""} ${compClass}`.trim(),
    };

    return (
        <div {...attributes}>
            <div className="m-modal-content__box">
                <button
                    type="button"
                    className="close-button"
                    onClick={rest.onClose}
                />
                <div className="m-modal-content">
                    <div className="m-modal-content__form">
                        <div className="m-modal-content__form__items registered">
                            <div className="m-modal-content__form__items__icon">
                                <img className="m-modal-content__form__items__icon--light" 
                                    src={imagenesEmpleo[0].file.url} 
                                    alt={"Icono información"} 
                                />
                                <img className="m-modal-content__form__items__icon--dark" 
                                    src={imagenesEmpleo[1].file.url} 
                                    alt={"Icono información"} 
                                />
                            </div>
                            <div className="m-modal-content__form__item__title">{tituloPrincipal}</div>
                            <div className="m-modal-content__form__item__msg">
                                {talentsSelectedIds > 1
                                    ? (rawToReact(descripcion.raw, contentfulRenderOptions))
                                    : rawToReact(descripcionFormulario.raw, contentfulRenderOptions)
                                }
                            </div>
                        </div>
                        <div className="m-modal-content__form__button">
                            <Button
                                type="link"
                                text={tituloBoton}
                                classname={`a-button__magenta dimensions`}
                                isDisabled={false}
                                href={`${talentsSelectedIds > 1 ? "./grupal/" : "./individual/"}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    );
};

export default ModalConocerTalento;